import { loadWebtexte } from "@phoenixreisen/gateway";
import { TRIPTYPE_RIVER, TRIPTYPE_SEE } from "../../../config";
const RoutesToWebtexts = {
    sea: [
        {
            start: "Cuxhaven",
            end: "Cuxhaven",
            webtext: "parken__text_hochsee__hafenpark_cuxhaven",
        },
        {
            start: "Bremerhaven",
            end: "Cuxhaven",
            webtext: "parken__text_hochsee__hafenpark_cuxhaven",
        },
        {
            start: "Cuxhaven",
            end: "Bremerhaven",
            webtext: "parken__text_hochsee__hafenpark_cuxhaven",
        },
        {
            start: "Bremerhaven",
            end: "Bremerhaven",
            webtext: "parken__text_hochsee__globus_bremerhaven",
        },
        {
            start: "Kiel",
            end: "Cuxhaven",
            webtext: "parken__text_hochsee__parken_und_meer",
        },
        {
            routes: ["DEU100", "DEU102B"],
            webtext: "parken__text_hochsee__hafenpark_cuxhaven",
        },
        {
            start: "Cuxhaven",
            end: "Kiel",
            webtext: "parken__text_hochsee__parken_und_meer",
        },
        {
            start: "Bremerhaven",
            end: "Kiel",
            webtext: "parken__text_hochsee__parken_und_meer",
        },
        {
            start: "Kiel",
            end: "Bremerhaven",
            webtext: "parken__text_hochsee__parken_und_meer",
        },
        {
            start: "Hamburg",
            end: "Bremerhaven",
            webtext: "parken__text_hochsee__parken_und_meer",
        },
        {
            start: "Bremerhaven",
            end: "Hamburg",
            webtext: "parken__text_hochsee__parken_und_meer",
        },
        {
            start: "Hamburg",
            end: "Kiel",
            webtext: "parken__text_hochsee__parken_und_meer",
        },
        {
            start: "Kiel",
            end: "Hamburg",
            webtext: "parken__text_hochsee__parken_und_meer",
        },
        {
            start: "Hamburg",
            end: "Hamburg",
            webtext: "parken__text_hochsee__parken_und_meer",
        },
        {
            start: "Kiel",
            end: "Kiel",
            webtext: "parken__text_hochsee__parken_und_meer",
        },
    ],
    river: [
        { start: "Köln", end: "Köln", webtext: "parken__text_fluss__globus_koeln" },
        {
            start: "Köln",
            end: "Passau",
            webtext: "parken__text_fluss__globus_koeln",
        },
        {
            start: "Passau",
            end: "Köln",
            webtext: "parken__text_fluss__globus_passau",
        },
        {
            start: "Passau",
            end: "Passau",
            webtext: "parken__text_fluss__globus_passau",
        },
    ],
};
const Model = {
    webtexte: null,
};
export function getFirstAndLastDock(booking) {
    const travs = booking["buchung/reiseteilnehmer"] ?? [];
    for (const trav of travs) {
        const cruises = trav["reiseteilnehmer/kreuzfahrten"] || [];
        if (cruises.length) {
            const firstCruise = cruises[0];
            const lastCruise = cruises[cruises.length - 1];
            const firstDock = firstCruise["kreuzfahrt/einschiffungshafen"] || null;
            const lastDock = lastCruise["kreuzfahrt/ausschiffungshafen"] || null;
            return {
                first: firstDock,
                last: lastDock,
            };
        }
    }
    return null;
}
export function startsInSupportedRoute(booking, supportedRoutes) {
    const bookingRoutes = booking["buchung/routen"]?.map((r) => r["route/schiff"].concat(r["route/route"]));
    if (Array.isArray(bookingRoutes) && bookingRoutes.length > 0) {
        const startRoute = bookingRoutes[0];
        for (const route of supportedRoutes) {
            const startRouteFound = route.routes?.find((r) => r === startRoute);
            if (startRouteFound) {
                return true;
            }
        }
    }
    return false;
}
export function startsAndEndsInSupportedDock(booking, supportedRoutes) {
    const docks = getFirstAndLastDock(booking);
    if (docks) {
        const firstDockName = (docks.first && docks.first["hafenaufenthalt/hafen-name"]) || "";
        const lastDockName = (docks.last && docks.last["hafenaufenthalt/hafen-name"]) || "";
        for (const route of supportedRoutes) {
            if (firstDockName.includes(route.start) &&
                lastDockName.includes(route.end)) {
                return true;
            }
        }
    }
    return false;
}
export function getWebtextNameByRoute(booking) {
    const bookingRoutes = booking["buchung/routen"]?.map((r) => r["route/schiff"].concat(r["route/route"]));
    if (Array.isArray(bookingRoutes) && bookingRoutes.length > 0) {
        const startRoute = bookingRoutes[0];
        if (isHighSea(booking)) {
            for (const route of RoutesToWebtexts.sea) {
                const startRouteFound = route.routes?.find((r) => r === startRoute);
                if (startRouteFound) {
                    return route.webtext;
                }
            }
        }
        else {
            for (const route of RoutesToWebtexts.river) {
                const startRouteFound = route.routes?.find((r) => r === startRoute);
                if (startRouteFound) {
                    return route.webtext;
                }
            }
        }
    }
    return null;
}
export function getWebtextNameByStartAndEnd(booking) {
    const docks = getFirstAndLastDock(booking);
    if (docks) {
        const firstDockName = (docks.first && docks.first["hafenaufenthalt/hafen-name"]) || "";
        const lastDockName = (docks.last && docks.last["hafenaufenthalt/hafen-name"]) || "";
        if (isHighSea(booking)) {
            for (const route of RoutesToWebtexts.sea) {
                if (firstDockName.includes(route.start) &&
                    lastDockName.includes(route.end)) {
                    return route.webtext;
                }
            }
        }
        else {
            for (const route of RoutesToWebtexts.river) {
                if (firstDockName.includes(route.start) &&
                    lastDockName.includes(route.end)) {
                    return route.webtext;
                }
            }
        }
    }
    throw new Error("Webtext für Parkenseite konnte nicht bestimmt werden.");
}
export function startsInThisOrNextYear(booking) {
    const thisYear = new Date().getFullYear();
    const nextYear = thisYear + 1;
    const dates = booking["buchung/reisezeitraum"];
    const startDate = dates?.[0] ?? null;
    const startDateYear = startDate?.split(".")[2] ?? null;
    const startYear = parseInt(startDateYear, 10);
    return startYear && startYear <= nextYear;
}
export function isHighSea(booking) {
    return booking && booking["buchung/reiseart"] === TRIPTYPE_SEE;
}
export function isRiver(booking) {
    return booking && booking["buchung/reiseart"] === TRIPTYPE_RIVER;
}
export function hasParkingOption(booking) {
    return ((isHighSea(booking) &&
        startsInThisOrNextYear(booking) &&
        (startsInSupportedRoute(booking, RoutesToWebtexts.sea) ||
            startsAndEndsInSupportedDock(booking, RoutesToWebtexts.sea))) ||
        (isRiver(booking) &&
            (startsInSupportedRoute(booking, RoutesToWebtexts.river) ||
                startsAndEndsInSupportedDock(booking, RoutesToWebtexts.river))));
}
export async function getWebtexte() {
    const categories = [
        "parken__ueberschrift",
        "parken__text_hochsee__hafenpark_cuxhaven",
        "parken__text_hochsee__globus_bremerhaven",
        "parken__text_hochsee__parken_und_meer",
        "parken__text_fluss__globus_passau",
        "parken__text_fluss__globus_koeln",
    ];
    return loadWebtexte(categories, "webtexte.parken");
}
export default Model;
